import ActionTypes from './actionTypes';

interface DisplayNotification {
    type: typeof ActionTypes.DISPLAY_NOTIFICATION;
}

interface HideNotification {
    type: typeof ActionTypes.HIDE_NOTIFICATION;
}

export function displayNotification(): DisplayNotification {
    return {
        type: ActionTypes.DISPLAY_NOTIFICATION,
    };
}

export function hideNotification(): HideNotification {
    return {
        type: ActionTypes.HIDE_NOTIFICATION,
    };
}

export type Action = DisplayNotification | HideNotification;

export type ActionCreator = typeof displayNotification | typeof hideNotification;
